import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/grammar/right_tips.png'


const _hoisted_1 = { class: "exercise-container" }
const _hoisted_2 = { class: "question-header" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = { class: "options-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "option-key"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "option-text"
}
const _hoisted_10 = {
  key: 0,
  class: "answer-section"
}
const _hoisted_11 = { class: "answer-header" }
const _hoisted_12 = { class: "correct-answer-text" }
const _hoisted_13 = { class: "explanation" }
const _hoisted_14 = { class: "explanation-text" }

import InnerContainer from "@/views/grammar/newGrammar/components/InnerContainer.vue";
import IconAnalysis from "@/assets/grammar/icon_analysis.png";
import IconActiveAnalysis from "@/assets/grammar/active_analysis.png";
import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Template4',
  props: {
  templateData: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

// 切换显示解析
function toggleAnalysis(index: any) {
  props.templateData.content[0].count1List[index].showAnalysis =
    !props.templateData.content[0].count1List[index].showAnalysis;
}

// 处理内容中的特殊标签
const processContent = (content) => {
  return content
    .replace(/<r>/g, '<span class="highlight-red">')
    .replace(/<\/r>/g, "</span>")
    .replace(/<l>/g, '<span class="highlight-blue">')
    .replace(/<\/l>/g, "</span>")
    .replace(/<y>/g, '<span class="highlight-yellow">')
    .replace(/<\/y>/g, "</span>")
    .replace(/<bl>/g, '<span class="highlight-blue">')
    .replace(/<\/bl>/g, "</span>")
    .replace(/<g>/g, '<span class="highlight-green">')
    .replace(/<\/g>/g, "</span>")
    .replace(/<u>/g, "<u>")
    .replace(/<\/u>/g, "</u>")
    .replace(/<b>/g, "<strong>")
    .replace(/<\/b>/g, "</strong>")
    .replace(/<i>/g, "<em>")
    .replace(/<\/i>/g, "</em>")
    .replace(/<br\/>/g, "<br/>");
};

const handleAnswer = (answer,opt,ev)=>{
  opt.showResult = !opt.showResult;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerContainer, {
    title: __props.templateData.pageTitle,
    "sub-title": __props.templateData.problem
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.templateData.content[0].count1List, (question, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "question-card"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", {
                class: "question-text",
                innerHTML: processContent(question.question)
              }, null, 8, _hoisted_3),
              _createElementVNode("img", {
                class: "analysis-icon",
                src: question.showAnalysis ? _unref(IconActiveAnalysis) : _unref(IconAnalysis),
                alt: "分析",
                onClick: ($event: any) => (toggleAnalysis(index))
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.count2List, (option) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: option.key,
                  class: _normalizeClass(["option-item", {
                'correct-answer': option.option == question.answer && question.showAnalysis,
                'highlight-green':option.showResult && option.option == question.answer,
                'highlight-red':option.showResult && option.option != question.answer,
              }]),
                  onClick: ($event: any) => (handleAnswer(question.answer,option,$event))
                }, [
                  (option.option)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createTextVNode(_toDisplayString(option.option), 1),
                        (option.option && option.optionContent)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "."))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (option.optionContent)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(option.optionContent), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_6)), [
                  [_vShow, option.option || option.optionContent]
                ])
              }), 128))
            ]),
            (question.showAnalysis)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[0] || (_cache[0] = _createElementVNode("img", {
                      class: "lightbulb-icon",
                      src: _imports_0,
                      alt: "正确答案"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_12, "正确答案: " + _toDisplayString(question.answer), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(question.answerAnalysis), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title", "sub-title"]))
}
}

})